import ResourceNotFound from './ResourceNotFound';
import OrderNotFound from './OrderNotFound';

export {
  ResourceNotFound,
  OrderNotFound,
};

export default ResourceNotFound;
